/**
 * Parses spacings
 * @param {string} [spacingStr]
 * @returns {string[]} Array with Rebass compatible breakpoint array spacings
 */
export const parseSpacing = (spacingStr = '') =>
  spacingStr.split(',').map((val) => val.trim());

/**
 * Spreads spacing into full form
 * e.g. "10px 20px" -> "10px 20px 10px 20px"
 * @param {string[]} spacingArr array of spacings
 * @returns {string[]} full spacings form
 */
const spreadSpacing = (spacingArr) =>
  Array(4)
    .fill(null)
    .map((_, i) => spacingArr[i] ?? spacingArr[i % 2] ?? spacingArr[0]);

/**
 * Basically does this
 * 1. 10px, 2 3 4, 10px 2rem
 * 2. ['10px', '2 3 4', '10px 2rem']
 * 3. [['10px'], [2, 3, 4], ['10px', '2rem']]
 * 4. [['10px', '10px', '10px', '10px'], [2, 3, 4, 3], ['10px', '2rem', '10px', '2rem']]
 * @param {string} spacingStr
 * @returns {object} Object with Rebass compatible breakpoint array spacings
 */
const getSpreadSpacings = (spacingStr) => {
  const parsedSpacings = parseSpacing(spacingStr);
  const splitSpacings = parsedSpacings.map((spacing) => spacing.split(' '));
  const spreadSpacings = splitSpacings.map(spreadSpacing);

  return {
    top: spreadSpacings.map((spacing) => spacing[0]),
    right: spreadSpacings.map((spacing) => spacing[1]),
    bottom: spreadSpacings.map((spacing) => spacing[2]),
    left: spreadSpacings.map((spacing) => spacing[3]),
  };
};

export const parseMargin = (spacingStr) => {
  const { top, right, bottom, left } = getSpreadSpacings(spacingStr);
  return {
    mt: top,
    mr: right,
    mb: bottom,
    ml: left,
  };
};

export const parsePadding = (spacingStr) => {
  const { top, right, bottom, left } = getSpreadSpacings(spacingStr);
  return {
    pt: top,
    pr: right,
    pb: bottom,
    pl: left,
  };
};
